import { Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Button from "@readai/common/components/Button";
import Stack, { Row } from "@readai/pulse/components/Stack";

export const Container = styled(Row)(({ theme }) => ({
  minHeight: "100vh",
  width: "100vw",
  minWidth: "350px",
  background: "linear-gradient(90deg, #4C47CC 0%, #7B61FF 100%)",
  color: "#FFF",
  padding: "20px",
  [theme.breakpoints.up("sm")]: {
    padding: "40px",
  },
  [theme.breakpoints.up("md")]: {
    padding: "90px",
  },
}));

export const LeftColumn = styled(Stack)({
  width: "530px",
  maxWidth: "100%",
  justifyContent: "center",
  flexShrink: 1,
});

export const RightColumn = styled(Stack)(({ theme }) => ({
  width: "550px",
  maxWidth: "100%",
  justifyContent: "center",
  flexShrink: 1,
  display: "none",
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

export const CtaButton = styled(Button)(({ theme, variant = "contained" }) => ({
  boxShadow: variant === "contained" ? undefined : "none",
  backgroundColor: variant === "contained" ? "#FFF" : "transparent",
  color: variant === "contained" ? theme.palette.shades.primary[500] : "#FFF",
  borderColor: variant === "outlined" ? "#FFF" : undefined,
  fontSize: "1rem",
  "&:hover": {
    backgroundColor:
      variant === "contained"
        ? theme.palette.shades.primary[50]
        : theme.palette.shades.primary[500],
    borderColor: variant === "outlined" ? "#FFF" : undefined,
  },
}));

export const StyledCopyButton = styled(Button)({
  height: "40px",
  width: "80px",
});

export const Text = styled(Typography)({
  fontSize: "1.125rem",
  fontWeight: 500,
  lineHeight: 32 / 18,
});

export const Heading = styled(Typography)({
  fontSize: "64px",
  maxWidth: "100%",
  fontWeight: 500,
  lineHeight: 1,
});

export const LinkButtonContainer = styled(Row)(({ theme }) => ({
  marginTop: theme.spacing(1),
  borderRadius: "6px",
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(1.5),
  width: "350px",
  maxWidth: "100%",
  backgroundColor: "#FFF",
  "&:hover": { cursor: "pointer" },
}));
